import { fromJS } from 'immutable'
import {
  PROJECT_INFORMATION_LIST_REQUEST,
  PROJECT_INFORMATION_LIST_SUCCESS,
  PROJECT_INFORMATION_LIST_FAILURE,
  PROJECT_INFORMATION_LIST_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case PROJECT_INFORMATION_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case PROJECT_INFORMATION_LIST_SUCCESS:
      return state
        .set('projects', fromJS(action.payload.projects))
        .set('users', fromJS(action.payload.users))
        .set('createableProjectType', fromJS(action.payload.createableProjectType))
        .set('isFetching', false)
    case PROJECT_INFORMATION_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case PROJECT_INFORMATION_LIST_RESET:
      return state
        .delete('projects')
        .delete('users')
        .delete('createableProjectType')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project-information/project-information-list-reducer.js